import * as React from 'react';
import { CardTitle, Card, Button, Option, Select, Input, CardContent, withGrid, Toast, ToastType  } from '../../../Components';
import { alterarLinkDoEvento, ValidationError } from '../../../Store';
import styled from 'styled-components';
import { media } from '../../../Themes';
import { format } from 'date-fns';
import { useState } from 'react';

interface IAgendamentoProps extends React.InputHTMLAttributes<any> {
  monografiaid: number;
  dataSugerida: Date | undefined;
  locais: Array<{ id: number, nome: string }>
  dia: string;
  hora: string;
  localId: number | string;
  linkEvento: string;
  agendamentoRealizado: boolean;
  disabled?: boolean;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  criarAgendamento: () => any;
  excluirAgendamento: () => any;
  validation: ValidationError<{ dataHora: string, localId: string }>;
}

const Grid = withGrid(CardContent);
const CardContentGrid = styled(Grid)`
  grid-template-columns: repeat(12, 1fr);
`;

const InputGrid = styled(Input) <any>`
  grid-column: ${p => p.gridColumn};
  margin: 0;

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const StyledText = styled.span`
  padding: 5px;
`;

const SelectGrid = InputGrid.withComponent(Select);

const ButtonGrid = styled(Button) <any>`
  max-width: fit-content;
  justify-self: flex-end;
  grid-column: ${p => p.gridColumn};

  ${media.zeroToDesktop(`
    grid-column: 1/12;
  `)}
`;

const AgendamentoCard: React.FC<IAgendamentoProps> = (props: IAgendamentoProps) => {
  const {
    monografiaid,
    dia,
    hora,
    localId,
    linkEvento,
    dataSugerida,
    locais,
    handleChange,
    validation,
    excluirAgendamento,
    criarAgendamento,
    agendamentoRealizado,
    disabled
  } = props;

  const [link, setLink] = useState(linkEvento);
  const [sucesso, setSucesso] = useState(false);

  function onLinkChange(e: { target: { value: React.SetStateAction<string>; }; }){
    setLink(e.target.value)
  }

  const AlterarLink = async (link: string,id:number) => {
    await alterarLinkDoEvento(id,link);
    setSucesso(true);
    }

  return (
    <>
    {sucesso &&
      <Toast type={ToastType.success}>
        <StyledText>Link Alterado</StyledText>
      </Toast> }
    <Card>
      <CardTitle>Agendamento</CardTitle>
      <CardContentGrid>
        <InputGrid
          gridColumn='1/4'
          label='Data e hora sugeridas'
          value={dataSugerida && format(dataSugerida, 'DD/MM/YYYY HH:mm')}
          disabled={true}
        />
        {!disabled?
          <InputGrid
          gridColumn='4/4'
          label='Link do Evento'
          value={linkEvento}
          name='linkEvento'
          onChange={handleChange}
          disabled={false}
        />:
        <InputGrid
          gridColumn='4/4'
          label='Link do Evento'
          value={link}
          name='linkEvento'
          onChange={onLinkChange}
          disabled={false}
        />}
        <InputGrid
          gridColumn='1/4'
          label='Data de apresentação'
          type='date'
          value={dia}
          onChange={handleChange}
          name='dia'
          hasError={validation && validation.dataHora}
          errorMessage={validation && validation.dataHora}
          disabled={disabled}
        />
        <InputGrid
          gridColumn='4/7'
          label='Horário'
          type='hora'
          mask='99:99'
          placeholder='00:00'
          value={hora}
          onChange={handleChange}
          name='hora'
          hasError={validation && validation.dataHora}
          disabled={disabled}
        />
        <SelectGrid
          gridColumn='7/10'
          name='localId'
          label='Sala'
          value={localId}
          onChange={handleChange}
          disabled={disabled}
          hasError={Boolean(validation && validation.localId && validation.localId.length)}
          errorMessage={validation && validation.localId && validation.localId[0]}
        >
          <Option value=''>Selecione a sala</Option>
          {locais.map(l =>
            <Option value={l.id} key={l.id}>
              {l.nome}
            </Option>
          )}
        </SelectGrid>
        {disabled &&
        <ButtonGrid
        gridColumn='9/13'
        color={'secondaryColor'}
        onClick={()=>{AlterarLink(link,monografiaid)}}
      >
        Alterar Link Evento
      </ButtonGrid>}
        <ButtonGrid
          gridColumn='10/13'
          color={agendamentoRealizado ? 'errorColor' : 'secondaryColor'}
          onClick={agendamentoRealizado ? excluirAgendamento : criarAgendamento}
        >
          {agendamentoRealizado ? 'Excluir Agendamento' : 'Agendar'}
        </ButtonGrid>
      </CardContentGrid>
    </Card>
    </>
  );
};

export default AgendamentoCard;
